import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import MenuIcon from '../../../common/icons/MenuIcon';
import UserIcon from '../../../common/icons/UserIcon';
import { LogoBlack, LogoWhite } from '../../../common/icons/Logos';

const MobileHeader = props => {
  const { isAuthenticated, toggleSidebarOpen } = props;

  const isTransparent = props.isTransparent || false;

  return (
    <div className={classnames({ 'm-header': !isTransparent, 'm-start-screen-header': isTransparent })}>
      <div className="is-flex">
        <a className="is-block" href="#" onClick={toggleSidebarOpen}>
          <MenuIcon className={classnames('desktop-menu-icon', { 'is-secondary': !isTransparent })} />
        </a>
        <Link to="/" className="is-flex align-items-center ml-20px">
          {isTransparent ? <LogoWhite isSmall /> : <LogoBlack isSmall />}
        </Link>
      </div>
      {!isAuthenticated && (
        <Link to="/auth" className={classnames('m-header-link', { 'is-transparent': isTransparent })}>
          Sign In
        </Link>
      )}
      {isAuthenticated && (
        <Link to="/profile" className="m-header-link">
          <UserIcon size={25} className={classnames('desktop-menu-icon', { 'is-secondary': !isTransparent })} />
        </Link>
      )}
    </div>
  );
};

MobileHeader.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  toggleSidebarOpen: PropTypes.func.isRequired,
  isTransparent: PropTypes.bool,
};

export default MobileHeader;
